import React from 'react';

import pluralize from 'pluralize';

import { useSelector } from 'bundles/research/index/store/hooks';
import { getCurrentTab } from '../store/selectors/ui';

import Controls from './controls';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCodeCompare } from '@fortawesome/pro-regular-svg-icons';

export default function CompsIndexHeaderEdgeCrm() {
  const currentTab = useSelector(getCurrentTab);
  const totalCount = useSelector(state => state.search.meta.totalCount);

  return (
    <div className="bg-card d-flex align-items-center border-bottom p-4 shadow z-1">
      <div className="d-flex flex-fill gap-2 align-items-stretch">
        <div className="align-self-center">
          <FontAwesomeIcon icon={faCodeCompare} size="xl" />
        </div>
        <h4 className="align-self-center">Comps</h4>
        {currentTab !== 'maps' &&
          <div className="d-none d-lg-flex text-muted border-start ms-4 ps-4 align-items-center">
            {pluralize('Comp', totalCount, true)}
          </div>
        }
      </div>

      <div>

        <Controls />
      </div>
    </div>
  );
}
